import cn from "classnames";
import type { ComponentPropsWithoutRef } from "react";

// Extends the native <input> attributes because everything not named below is
// spread straight onto the underlying element (value, checked, onChange, name,
// required, ...). `type` therefore accepts any input type, not just "text".
interface InputProps extends ComponentPropsWithoutRef<"input"> {
  label?: string;
}

const Input = ({ label, type = "text", placeholder, className = "", ...rest }: InputProps) => {
  return (
    <div className={cn("mb-4", { [className]: className })}>
      {label && (
        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={label}>
          {label}
        </label>
      )}
      <input
        className="block w-full bg-gray-100 text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight focus:outline-none"
        id={label}
        type={type}
        placeholder={placeholder}
        {...rest}
      />
    </div>
  );
};

export default Input;
